<template>
  <div class='mt-1'>
    <b-modal
      ref='ventilationInstalledSpecificallyForTheProductionProcessModal'
      id='ventilationInstalledSpecificallyForTheProductionProcessModal'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='xl'
      @show='showModal()'
      :no-close-on-esc='loading'
      :no-close-on-backdrop='loading'
    >
      <b-overlay
        :show='lookingTermsOfUse'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
      >
        <section class='modal-font-family'>
          <section class='d-flex justify-content-between align-items-start  w-100 mb-2 mt-1'>
            <section>
              <span class='title'>{{ step === 1 ? 'Condição de ventilação instalada e específica para o processo produtivo' : 'Nível de Controle Personalizado' }}</span><br/>
              <span class='sub-title'>Selecione uma das opções abaixo</span>
            </section>
            <b-icon
              @click='closeModal()'
              class='cursor-pointer'
              font-scale='2.2'
              icon='x'
              color='#022245'
            >
            </b-icon>
          </section>

          <section class='w-100' v-if='step === 1'>
            <b-form-radio-group
              class='container-level'
              v-model='selectedOption'
            >
              <section
                class=' level'
                :class="selectedOption === 2 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='2'>
                  <span class='level-text-radio'>
                    Nível de Controle 1
                  </span>
                </b-form-radio>
                <hr />
                <section class='level-img'>
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />

                </section>

                <section class='d-flex justify-content-between align-items-start'>
                  <p class='level-text-orintation mr-2'>
                    Ventilação geral com menos de 3 a 6 trocas de ar por hora
                  </p>
                </section>
              </section>


              <section
                class=' level'
                :class="selectedOption === 3 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='3'>
                  <span class='level-text-radio'>
                    Nível de Controle 2
                  </span>
                </b-form-radio>
                <hr />
                <section class='level-img'>
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />

                </section>

                <section class='d-flex justify-content-between align-items-start'>
                  <p class='level-text-orintation mr-2'>
                    Boa ventilação geral com menos de 6 a 12 trocas de ar por hora
                  </p>
                </section>
              </section>


              <section
                class=' level'
                :class="selectedOption === 4 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='4'>
                  <span class='level-text-radio'>
                    Nível de Controle 3
                  </span>
                </b-form-radio>
                <hr />
                <section class='level-img'>
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />

                </section>

                <section class='d-flex justify-content-between align-items-start'>
                  <p class='level-text-orintation mr-2'>
                    Boa ventilação geral com exaustão local nos pontos de emissão
                  </p>
                </section>
              </section>


              <section
                class=' level'
                :class="selectedOption === 5 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='5'>
                  <span class='level-text-radio'>
                    Nível de Controle 4
                  </span>
                </b-form-radio>
                <hr />
                <section class='level-img'>
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />

                </section>

                <section class='d-flex justify-content-between align-items-start'>
                  <p class='level-text-orintation mr-2'>
                    Captura no ponto de emissão com contenção
                  </p>
                </section>
              </section>


              <section
                class=' level'
                :class="selectedOption === 6 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='6'>
                  <span class='level-text-radio'>
                    Nível de Controle 5
                  </span>
                </b-form-radio>
                <hr />
                <section class='level-img'>
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />

                </section>

                <section class='d-flex justify-content-between align-items-start'>
                  <p class='level-text-orintation mr-2'>
                    Enclausuramento do agente (uma barreira de proteção)
                  </p>
                </section>
              </section>


              <section
                class=' level'
                :class="selectedOption === 7 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='7'>
                  <span class='level-text-radio'>
                    Nível de Controle 6
                  </span>
                </b-form-radio>
                <hr />
                <section class='level-img'>
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/filledVentilation.svg'
                    alt=''
                  />

                </section>

                <section class='d-flex justify-content-between align-items-start'>
                  <p class='level-text-orintation mr-2'>
                    Enclausuramento primário e secundário (duas barreiras de proteção)
                  </p>
                </section>
              </section>


              <section
                class=' level'
                :class="selectedOption === 'custom' ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value="'custom'">
                  <span class='level-text-radio'>
                    Nível de Controle Personalizado
                  </span>
                </b-form-radio>
                <hr />
                <section class='d-flex justify-content-between align-items-start'>
                  <p class='level-text-orintation mr-2'>
                    Defina manualmente o nível de controle
                  </p>
                </section>
              </section>


              <section
                class=' level'
                :class="selectedOption === 1 ? 'ventilation-level-selected': 'ventilation-level-not-selected'"
              >
                <b-form-radio :value='1'>
                  <span class='level-text-radio'>
                    Nenhuma das opções anteriores
                  </span>
                </b-form-radio>
                <hr />
                <section class='level-img'>
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />
                  <img
                    class='mr-3'
                    width='25'
                    height='25'
                    src='../../../../../assets/images/ventilation.svg'
                    alt=''
                  />

                </section>

                <section class='d-flex justify-content-between align-items-start'>
                  <p class='level-text-orintation mr-2'>
                    Caso nenhuma das outras opções seja condizente com sua condição de ventilação instalada
                  </p>
                </section>
              </section>
            </b-form-radio-group>
          </section>

          <section class='w-100' v-if='step === 2'>
            <section class='custom-control-scale'>
              <section class='custom-control-scale__numbers'>
                <button
                  v-for='number in 6'
                  :key='number'
                  type='button'
                  class='custom-control-scale__number'
                  :class="{ 'custom-control-scale__number--selected': customScaleValue === number }"
                  @click='selectCustomScale(number)'
                >
                  {{ number }}
                </button>
              </section>

              <section class='custom-control-scale__track'>
                <span
                  v-if='customScaleValue'
                  class='custom-control-scale__marker'
                  :style="{ left: markerPosition }"
                ></span>
              </section>

              <section class='custom-control-scale__labels'>
                <span class='custom-control-scale__label custom-control-scale__label--bad'>
                  1 - Pouco ventilado (ruim)
                </span>
                <span class='custom-control-scale__label custom-control-scale__label--good'>
                  6 - Muito ventilado (bom)
                </span>
              </section>
            </section>

            <section class='custom-control-upload mt-4'>
              <section class='custom-control-upload__header'>
                <span class='custom-control-upload__title'>
                  Anexe aqui fotos, vídeos e documentos que comprovem o nível de controle indicado
                </span>
                <span class='custom-control-upload__badge'>(Opcional)</span>
              </section>

              <section
                class='custom-control-upload__dropzone'
                @click='triggerFileSelect()'
                @dragover.prevent
                @drop.prevent='onFilesDropped($event)'
              >
                <b-icon icon='cloud-arrow-up' font-scale='2' variant='secondary'></b-icon>
                <span class='custom-control-upload__cta'>
                  Arraste arquivos aqui ou clique para selecionar
                </span>
                <span class='custom-control-upload__hint'>
                  Fotos, vídeos e documentos aceitos
                </span>
                <input
                  ref='controlLevelFileInput'
                  type='file'
                  multiple
                  class='d-none'
                  @change='onFilesSelected($event)'
                />
              </section>

              <b-overlay
                :show='uploadingFiles'
                rounded
                opacity='0.6'
                spinner-small
                spinner-variant='primary'
              >
                <ul v-if='controlLevelFiles.length' class='custom-control-upload__list'>
                  <li
                    v-for='(file, index) in controlLevelFiles'
                    :key='index'
                    class='custom-control-upload__item'
                  >
                    <span class='custom-control-upload__item-name'>{{ file.name }}</span>
                    <section class='custom-control-upload__item-actions'>
                      <b-icon
                        icon='download'
                        class='cursor-pointer'
                        variant='primary'
                        @click='downloadFile(file)'
                      ></b-icon>
                      <b-icon
                        icon='x'
                        class='cursor-pointer'
                        @click='removeFile(index)'
                      ></b-icon>
                    </section>
                  </li>
                </ul>
              </b-overlay>
            </section>
          </section>

          <section class='disclaimer mt-4' v-if='step === 2'>
            <b-icon
              class='disclaimer-icon'
              font-scale='1.4'
              icon='exclamation-triangle-fill'
            >
            </b-icon>
            <p class='disclaimer-text'>
              <span class='disclaimer-title'>Aviso: </span>a presença de ar-condicionado não significa, necessariamente, que há renovação de ar no ambiente, pois muitos sistemas apenas circulam o ar interno. Para esta avaliação, considere como ventilação artificial/mecânica apenas quando houver circulação, renovação, insuflação ou exaustão efetiva do ar.
            </p>
          </section>

          <section class='mt-4'>
            <b-alert show variant='danger' :class='{ hidden: !error }'>
              {{ error }}<br />
            </b-alert>
          </section>

          <section class='d-flex justify-content-between mt-4 w-100'>
            <button
              class='btn-cancel'
              @click='closeModal()'
            >
              <span>Cancelar</span>
            </button>

            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class=''
              style='width: 66%'
            >
              <button
                class='w-100 btn-add'
                style='width: 100%'
                @click='step === 1 ? handlePrimaryStepOne() : handlePrimaryStepTwo()'
              >
                <span> Finalizar condições de ventilação </span>
              </button>
            </b-overlay>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h6 class='text-primary'>Buscando codições de uso...</h6>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { optionsVentilationIdentified } from '@/mocks/optionsVentilationIdentified'
import { upload } from '@/utils/upload'

export default {
  name: 'VentilationInstalledSpecificallyForTheProductionProcessModal',
  components: {},
  props: {
    termsOfUseId: {
      type: String,
      required: false,
      default: null
    },
    productId: {
      type: String,
      required: false,
      default: null
    },
    productHierarchyId: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      lookingTermsOfUse: false,
      titles: {
        1: `Condição de ventilação do ambiente de trabalho de forma geral`,
        2: `Condição de ventilação instalada e específica para o processo produtivo`
      },
      ventilation: 2,
      ventilationConditionsEnvironmentWorkGeneralForm: 1,
      specificInstalledVentilationConditionsProductionProcess: 3,
      step: 1,
      selectedOption: null,
      customScaleValue: null,
      controlLevelFiles: [],
      uploadingFiles: false,
      termsOfUse: {
        ventilationWorkEnvironmentGeneral: null,
        ventilationInstalledSpecificallyForTheProductionProcess: null,
        isCustomControlLevel: false,
        controlLevelEvidenceFiles: [],
      },
      optionsVentilationIdentified: []
    }
  },
  async mounted() {
    try {

    } catch (e) {
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    disabled() {
      return !(this.termsOfUse.ventilationIdentified)
    },
    error() {
      return this.$store.getters['access/error']
    },
    markerPosition() {
      if (!this.customScaleValue) {
        return '0%'
      }
      return `${((this.customScaleValue - 1) / 5) * 100}%`
    },
  },
  methods: {
    ...mapActions('termsOfUse', {
      handleCreate: 'handleCreate',
      handleGet: 'handleGet',
      handleUpdade: 'handleUpdade'
    }),
    async closeModalVentilationIdentified() {
      try {
        this.$bvModal.hide('ventilationIdentified')
      } catch (e) {

      }
    },

    async showModal() {
      try {
        await this.$store.dispatch('access/updateError', '')
        Object.assign(this.optionsVentilationIdentified, optionsVentilationIdentified)
        this.optionsVentilationIdentified = optionsVentilationIdentified
        this.step = 1
        this.selectedOption = null
        this.customScaleValue = null
        this.controlLevelFiles = []
        this.termsOfUse = {
          ventilationWorkEnvironmentGeneral: null,
          ventilationInstalledSpecificallyForTheProductionProcess: null,
          isCustomControlLevel: false,
          controlLevelEvidenceFiles: [],
        }
        this.ventilation = 1
        if (this.termsOfUseId) {
          await this.get()
        }
      } catch (e) {

      }
    },

    async next() {
      try {
        await this.$store.dispatch('access/updateError', '')
        if(!this.termsOfUse.ventilationWorkEnvironmentGeneral){
          await this.$store.dispatch('access/updateError', 'Selecione o nível de Ventilação')
          return
        }
        this.ventilation = 2
      } catch (e) {
      }
    },

    selectCustomScale(number) {
      this.customScaleValue = number
    },

    triggerFileSelect() {
      this.$refs.controlLevelFileInput.click()
    },

    async onFilesSelected(event) {
      await this.uploadFiles(Array.from(event.target.files))
      event.target.value = ''
    },

    async onFilesDropped(event) {
      await this.uploadFiles(Array.from(event.dataTransfer.files))
    },

    async uploadFiles(files) {
      if (!files.length) {
        return
      }
      try {
        this.uploadingFiles = true
        for (const file of files) {
          const url = await upload(file)
          if (url) {
            this.controlLevelFiles.push({ name: file.name, url })
          }
        }
      } catch (e) {
        this.$bvToast.toast('Não foi possível enviar o(s) arquivo(s), tente novamente.', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
      } finally {
        this.uploadingFiles = false
      }
    },

    removeFile(index) {
      this.controlLevelFiles.splice(index, 1)
    },

    downloadFile(file) {
      if (!file || !file.url) {
        return
      }
      const link = document.createElement('a')
      link.href = file.url
      link.download = file.name || ''
      link.target = '_blank'
      link.rel = 'noopener'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    async handlePrimaryStepOne() {
      await this.$store.dispatch('access/updateError', '')
      if (!this.selectedOption) {
        await this.$store.dispatch('access/updateError', 'Selecione a condição de ventilação instalada e específica para o processo produtivo')
        return
      }
      if (this.selectedOption === 'custom') {
        this.step = 2
        return
      }
      this.termsOfUse.ventilationInstalledSpecificallyForTheProductionProcess = this.selectedOption
      this.termsOfUse.isCustomControlLevel = false
      this.termsOfUse.controlLevelEvidenceFiles = []
      this.persist()
    },

    async handlePrimaryStepTwo() {
      await this.$store.dispatch('access/updateError', '')
      if (!this.customScaleValue) {
        await this.$store.dispatch('access/updateError', 'Selecione o nível de controle na escala de 1 a 6')
        return
      }
      this.termsOfUse.ventilationInstalledSpecificallyForTheProductionProcess = this.customScaleValue
      this.termsOfUse.isCustomControlLevel = true
      this.termsOfUse.controlLevelEvidenceFiles = this.controlLevelFiles
      this.persist()
    },

    persist() {
      if (this.termsOfUseId) {
        this.update()
        return
      }
      this.create()
    },

    async create() {
      try {
        if(!this.termsOfUse.ventilationInstalledSpecificallyForTheProductionProcess){
          await this.$store.dispatch('access/updateError', 'Selecione o nível de Controle')
          return
        }
        this.loading = true
        this.termsOfUse.product = this.productId
        this.termsOfUse.productHierarchyId = this.productHierarchyId
        this.termsOfUse.fields = ['Condição de ventilação instalada e específica para o processo produtivo']
        const { data, status } = await this.handleCreate(this.termsOfUse)
        this.loading = false
        let message = data.message
        let variant = 'success'
        if (status !== 201) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeModal()
        this.$emit('update')
      } catch (e) {
        this.$bvToast.toast('Não foi possível cadastrar a condição de ventilação do ambiente de trabalho de forma geral e a condição de ventilação instalada e específica para o processo produtivo, verifique os dados e tente novamente.', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 10000
        })
        this.loading = false
        this.closeModal()
        this.$emit('update')
      }
    },

    async update() {
      try {
        if(!this.termsOfUse.ventilationInstalledSpecificallyForTheProductionProcess){
          await this.$store.dispatch('access/updateError', 'Selecione a condição de ventilação instalada e específica para o processo produtivo\n')
          return
        }
        this.loading = true
        this.termsOfUse.fields = ['Condição de ventilação instalada e específica para o processo produtivo']
        const { data, status } = await this.handleUpdade(this.termsOfUse)
        this.loading = false
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeModal()
        this.$emit('update')
      } catch (e) {
        this.$bvToast.toast('Não foi possível atualizar a condição de ventilação do ambiente de trabalho de forma geral e a condição de ventilação instalada e específica para o processo produtivo, verifique os dados e tente novamente.', {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 10000
        })
        this.loading = false
        this.closeModal()
        this.$emit('update')
      }
    },

    async get() {
      try {
        this.lookingTermsOfUse = true
        const { data } = await this.handleGet(this.termsOfUseId)
        const {
          ventilationWorkEnvironmentGeneral,
          ventilationInstalledSpecificallyForTheProductionProcess,
          isCustomControlLevel,
          controlLevelEvidenceFiles,
          _id
        } = data.termsOfUse
        this.termsOfUse.ventilationWorkEnvironmentGeneral = ventilationWorkEnvironmentGeneral
        this.termsOfUse.ventilationInstalledSpecificallyForTheProductionProcess = ventilationInstalledSpecificallyForTheProductionProcess
        this.termsOfUse.isCustomControlLevel = isCustomControlLevel || false
        this.termsOfUse.controlLevelEvidenceFiles = controlLevelEvidenceFiles || []
        this.termsOfUse._id = _id
        this.controlLevelFiles = controlLevelEvidenceFiles || []
        if (isCustomControlLevel) {
          this.selectedOption = 'custom'
          this.customScaleValue = ventilationInstalledSpecificallyForTheProductionProcess
        } else {
          this.selectedOption = ventilationInstalledSpecificallyForTheProductionProcess
        }
        this.lookingTermsOfUse = false
      } catch (e) {
      }
    },

    closeModal() {
      if (this.loading) {
        return
      }
      this.$bvModal.hide('ventilationInstalledSpecificallyForTheProductionProcessModal')
    }
  },
  created() {
  }
}
</script>
<style lang='scss' scoped>
.btn-cancel {
  background: transparent !important;
  border-radius: 4px !important;
  border: 1px solid var(--navy-blue) !important;
  width: 32%!important;
  padding: 6px 0;
  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 4px !important;
  border: 1px solid var(--navy-blue) !important;
  width: 66%;
  padding: 6px 0;
  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.modalVentilacao {
  display: inline-block;
  margin: 10px;
  justify-content: center;
  cursor: pointer;

  .img-caption {
    text-align: center;

    .caption {
      font-size: 13px;
      text-align: center;
      max-width: 230px;
    }
  }
}

.ventilationIdentified {
  .label {
    font-size: 18px;
    font-weight: 700;
  }

  .btn {
    width: 100%;
    min-height: 48px;
    border: 1px solid var(--border-input);
    border-radius: 4px;
    outline: none !important;
    text-align: left;
  }

}

.title{
  font-size: 22px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: var(--navy-blue)
}
.sub-title{
  font-size: 16px;
  font-weight: 400;
  line-height: 19.5px;
  text-align: left;
  color: #808080;
}

.ventilation-level-not-selected {
  border: 1px solid #D9D9D9;
  .level-text-radio {
    font-size: 14px;
    font-weight: 700;
    color: #808080;
  }
}
.ventilation-level-selected {
  border: 1px solid #022245;
  .level-text-radio {
    font-size: 14px;
    font-weight: 700;
    color: #022245;
  }
}

.level {
  border-radius: 4px;
  padding: 10px;
  margin: 5px;
  //width: 32%;
  .level-img {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
  }

  .level-text-orintation {
    font-size: 14px;
    font-weight: 400;

  }
}

hr {
  background-color: #D9D9D9;
}

.custom-control-scale {
  padding: 24px;
  border-radius: 8px;
  background: #F9FAFB;

  .custom-control-scale__numbers {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .custom-control-scale__number {
    background: transparent;
    border: none;
    outline: none;
    padding: 0 8px;
    font-size: 16px;
    color: #262626;
    cursor: pointer;

    &--selected {
      font-weight: 700;
    }
  }

  .custom-control-scale__track {
    position: relative;
    height: 6px;
    margin: 12px 14px 8px 0;
    border-radius: 4px 0 0 4px;
    background: linear-gradient(to right, #D32F2F, #F9A825, #43A047);

    &::after {
      content: '';
      position: absolute;
      left: 100%;
      top: 50%;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 14px solid #43A047;
      transform: translateY(-50%);
    }
  }

  .custom-control-scale__marker {
    position: absolute;
    top: 50%;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #262626;
    border: 2px solid #FFFFFF;
    transform: translate(-50%, -50%);
  }

  .custom-control-scale__labels {
    display: flex;
    justify-content: space-between;
  }

  .custom-control-scale__label {
    font-size: 16px;
    font-weight: 700;

    &--bad {
      color: #D32F2F;
    }

    &--good {
      color: #43A047;
    }
  }
}

.custom-control-upload {
  .custom-control-upload__header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
  }

  .custom-control-upload__title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
  }

  .custom-control-upload__badge {
    padding: 2px 8px;
    border-radius: 4px;
    background: #E3F2FD;
    font-size: 10px;
    font-weight: 700;
    color: #022245;
  }

  .custom-control-upload__dropzone {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 32px;
    border: 2px dashed #D9D9D9;
    border-radius: 8px;
    cursor: pointer;
  }

  .custom-control-upload__cta {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
  }

  .custom-control-upload__hint {
    font-size: 12px;
    color: #808080;
  }

  .custom-control-upload__list {
    list-style: none;
    padding: 0;
    margin: 12px 0 0;
  }

  .custom-control-upload__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    margin-bottom: 8px;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    font-size: 14px;
    color: #262626;
  }

  .custom-control-upload__item-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }
}

.disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border-left: 4px solid #F9A825;
  background: #FFF8E1;

  .disclaimer-icon {
    flex-shrink: 0;
    color: #F9A825;
  }

  .disclaimer-text {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: #262626;

    .disclaimer-title {
      font-weight: 700;
    }
  }
}

.container-level{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(32%, auto));
}
</style>
